export default function Manual() {
    return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.01" width="42" height="42" fill="white" />
            <path
                d="M13.1646 30.0455H12.0676C10.7476 30.0455 9.6792 28.9943 9.6792 27.6974V10.3481C9.6792 9.05195 10.7476 8 12.0676 8H25.7894C27.1086 8 28.1778 9.05195 28.1778 10.3481V10.7465"
                stroke="white"
                strokeWidth="1.21117"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.6562 33.656V29.3449C24.6562 28.264 25.6355 27.3882 26.844 27.3882H31.6645L24.6562 33.656Z"
                stroke="white"
                strokeWidth="1.21117"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M17.2422 17.6943H27.5846" stroke="white" strokeWidth="1.21117" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.2422 22.3911H27.5846" stroke="white" strokeWidth="1.21117" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.2422 27.0859H22.4138" stroke="white" strokeWidth="1.21117" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M24.6552 33.6563H15.5524C14.2332 33.6563 13.1641 32.6051 13.1641 31.3082V13.9589C13.1641 12.662 14.2332 11.6108 15.5524 11.6108H29.2751C30.5943 11.6108 31.6635 12.662 31.6635 13.9589V27.3885"
                stroke="white"
                strokeWidth="1.21117"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
